import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import useSeo from "@/hooks/useSeo";

export default function ForgotPassword() {
  useSeo({
    title: "Recupera password",
    description: "Password dimenticata? Ricevi il link di reset via email in un minuto. Il link scade dopo 30 minuti per la tua sicurezza.",
    path: "/forgot-password",
    noindex: true,
  });
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password/request", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore. Riprova più tardi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#FAF9F6] p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#E8E4D9] p-8 shadow-sm">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#4A4A4A] hover:text-[#0A0A0A] mb-6" data-testid="back-to-login">
          <ArrowLeft className="w-3.5 h-3.5" /> Torna al login
        </Link>
        {sent ? (
          <div className="text-center" data-testid="reset-sent-panel">
            <div className="mx-auto w-14 h-14 rounded-full bg-emerald-50 border border-emerald-200 grid place-items-center mb-4">
              <CheckCircle2 className="w-7 h-7 text-emerald-600" />
            </div>
            <h1 className="font-display font-extrabold text-3xl tracking-tighter">Controlla la tua email</h1>
            <p className="text-[#4A4A4A] mt-3 text-sm">
              Se l&apos;indirizzo <span className="font-mono">{email}</span> è associato a un account, ti abbiamo inviato un link per reimpostare la password. Il link scade tra 30 minuti.
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-display font-extrabold text-3xl tracking-tighter">
              Reimposta{" "}
              <span className="font-serif-accent text-[#1D4ED8]">password</span>
            </h1>
            <p className="text-[#4A4A4A] mt-2 text-sm">Ti invieremo un link via email per crearne una nuova.</p>
            <form onSubmit={submit} className="mt-6">
              <label className="block text-sm font-medium text-[#0A0A0A] mb-1.5">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#737373]" />
                <input
                  type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                  className="w-full h-11 pl-9 pr-3 rounded-md border border-[#E8E4D9] bg-white focus:border-[#0A0A0A] focus:ring-2 focus:ring-[#0A0A0A]/10 outline-none text-sm"
                  placeholder="tu@studio.it"
                />
              </div>
              <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                className="mt-6 w-full h-11 rounded-full bg-[#0A0A0A] text-white font-semibold text-sm hover:bg-[#1D4ED8] disabled:opacity-70 transition-colors inline-flex items-center justify-center gap-2">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Invia link di reset"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
